import Text from "components/Text";
import { CommonWrapper } from "pages/shared";
import styled from "styled-components";
import theme from "theme";

export const ProfileWrapper = styled.div``;

export const ProfileInnerWrapper = styled(CommonWrapper)`
    padding-top: 7rem;
`;

export const FlexContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: flex-start;
    gap: 28px;
    padding-top: 2rem;

    @media (${theme.breakpoints.mobileL}) {
        padding-top: 0.5rem;
    }
`;

export const LeftSection = styled.div`
    width: 66%;
    border-radius: 14px;

    @media (${theme.breakpoints.tabletL}) {
        width: 100%;
    }
`;

export const RightSection = styled.div`
    width: 33%;
    display: none;
`;

export const CustomUrlSection = styled.div`
    width: 100%;
    background-color: ${({ theme }) => theme.colors.grey.dark};
    border-radius: 14px;
    padding: 30px 25px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const CustomUrlButtonSection = styled.div`
    margin-top: 60px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const ResourcesSection = styled.div`
    width: 100%;
    border-radius: 14px;
    padding: 25px;
    display: flex;
    flex-direction: column;
    gap: 9px;
    background-color: #fff;
    margin-top: 21px;
`;

export const ResourcesList = styled(ResourcesSection)`
    gap: 16px;
    border-radius: 0;
    padding: 0;
    margin-top: 27px;
`;

export const ResourcesItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 11px;
    &:hover {
        ${Text.Style} {
            text-decoration: underline;
        }
    }
`;
